export function getUserAuthToken() {
  const localJwt = localStorage.getItem('servantica_jwt');
  if (localJwt) {
    return { token: localJwt, provider: 'local-jwt' };
  }

  const keycloakAccess = localStorage.getItem('access_token');
  if (keycloakAccess) {
    return { token: keycloakAccess, provider: 'keycloak' };
  }

  const idToken = localStorage.getItem('id_token');
  if (idToken) {
    return { token: idToken, provider: 'id_token' };
  }

  const refresh = localStorage.getItem('refresh_token');
  if (refresh) {
    return { token: refresh, provider: 'refresh' };
  }

  return null;
}

export function getAuthHeader() {
  const userToken = getUserAuthToken();
  if (userToken?.token) {
    return { Authorization: `Bearer ${userToken.token}` };
  }
  return {};
}
